import { ReactNode } from "react"

interface CenterContentsProps {
    children: ReactNode
}

function CenterContents(props: CenterContentsProps) {
    return (
        <div className={"w-full flex flex-col items-center justify-center p-4"}>
            {props.children}
        </div>
    )
}

export default CenterContents
